import {
  http,
  delay,
  HttpResponse,
} from 'msw';

import { createMockEndpoint } from '@/mocks/create-mock-endpoint';
import { CampaignDetailResponse } from '@/repositories/generated';

const response: CampaignDetailResponse = {
  id: '1',
  publicName: 'test 公開名称',
  name: 'test 管理名称',
  remarks: 'This is note.',
  createdAt: '2022-01-15T20:30',
  status: 'NEW',
  approvalStatus: 'WITHDRAWAL',
  campaignTarget: {
    targetSelection: 'CSV_UPLOAD',
    companiesCount: 100,
    shopsCount: 240,
    actionType: 'PREPAID_SETTLEMENT',
    houseFlg: true,
    smartCodeFlg: true,
    startDateTime: '2022-06-15T11:30:57.115Z',
    endDateTime: '2022-06-15T11:30:57.115Z',
    companies: [
      {
        id: '00001',
        name: 'テスト企業',
      },
    ],
    shops: [
      {
        id: '12345678',
        name: 'テスト店舗',
      },
    ],
    walletServices: [
      {
        id: '001',
        name: 'wsmt',
      },
    ],
    revisedEndDateTime: '2022-06-15T11:30:57.115Z',
  },
  pointInfo: {
    useStartPattern: 'DAYS_LATER',
    useStartAddValue: 10,
    accountType: 'BONUS_VALUE',
    grantCondition: [
      {
        amountTo: 1000,
        amountFrom: 100000,
        grantType: 'AMOUNT',
        rate: 5.5,
        amount: 100,
      },
    ],
    pointExpire: {
      expiredPattern: 'DAYS_LATER',
      dayCount: 15,
      monthCount: 3,
      yearCount: 2,
      baseMonth: 5,
      specifiedDate: '2022-05-30',
    },
  },
  applies: [
    {
      applicantId: '1',
      applyContent: 'NEW',
      name: 'applicant',
      applyDateTime: '2022-06-15T11:30:57.115Z',
      approvalStatus: 'WITHDRAWAL',
    },
  ],
};

export const campaignWithdraw = http.patch(
  createMockEndpoint('/campaign/:id/withdraw'),
  async () => {
    await delay(500);
    return HttpResponse.json(response, { status: 200 });
  },
);
